import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ArrowRight, ShieldCheck, CreditCard, Ruler } from 'lucide-react';
import { trackMetaEvent } from '../hooks/useMetaPixel';
const SIZES = [{
  label: 'S',
  url: 'https://argcompras.com/cart/52022828040485:1'
}, {
  label: 'M',
  url: 'https://argcompras.com/cart/52022828073253:1'
}, {
  label: 'L',
  url: 'https://argcompras.com/cart/52022828106021:1'
}, {
  label: 'XL',
  url: 'https://argcompras.com/cart/52022828138789:1'
}, {
  label: '2XL',
  url: 'https://argcompras.com/cart/52022828171557:1'
}, {
  label: '3XL',
  url: 'https://argcompras.com/cart/52022828204325:1'
}];
export function OfferStack() {
  const [selectedSize, setSelectedSize] = useState<string | null>(null);
  const [shakeBtn, setShakeBtn] = useState(false);
  const selectedSizeObj = SIZES.find(s => s.label === selectedSize);
  const handleCTAClick = (e: React.MouseEvent) => {
    if (!selectedSizeObj) {
      e.preventDefault();
      setShakeBtn(true);
      setTimeout(() => setShakeBtn(false), 600);
      document.getElementById('size-selector')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return;
    }
    trackMetaEvent('AddToCart', {
      content_name: `Kit Vientre Plano 21D - Talle ${selectedSize}`,
      content_type: 'product',
      value: 49990,
      currency: 'ARS'
    });
  };
  return <section id="oferta" className="py-24 px-4 md:px-8 bg-cream" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brown-deep mb-4" data-id="element-153">
            ¿Lista para el cambio?
          </h2>
          <p className="text-xl text-brown-medium" data-id="element-154">
            21 días separan tu versión actual de tu versión "Efecto Vacío"
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-gold/20 relative" data-id="element-155">
          {/* Badge */}
          <div className="bg-gold text-white text-center py-3 font-bold tracking-widest text-sm uppercase" data-id="element-156">
            TRATAMIENTO COMPLETO
          </div>

          <div className="p-8 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-157">
            {/* Left: What you get */}
            <div data-id="element-158">
              <h3 className="text-2xl font-serif font-bold text-brown-deep mb-6" data-id="element-159">
                Tu Kit Incluye:
              </h3>
              <ul className="space-y-4" data-id="element-160">
                {['Faja Térmica Premium', 'Ebook Método 21D (Protocolo Digital)', 'Guía de Masajes Linfáticos', 'Soporte por WhatsApp'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-161">
                    <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-162">
                      <Check className="w-4 h-4 text-green-600" data-id="element-163" />
                    </div>
                    <span className="text-brown-deep font-medium" data-id="element-164">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8 p-4 bg-rose/30 rounded-lg border border-rose text-brown-deep text-sm" data-id="element-165">
                <span className="font-bold" data-id="element-166">🎁 Bonus:</span> Acceso a comunidad
                exclusiva de clientas.
              </div>
            </div>

            {/* Right: Size selector + Price & CTA */}
            <div className="flex flex-col items-center md:items-start" data-id="element-167">
              {/* Size Guide */}
              <div className="w-full mb-6 rounded-2xl border border-gold/20 overflow-hidden bg-cream/50" data-id="element-168">
                <div className="px-4 pt-4 pb-3" data-id="element-169">
                  <p className="text-sm text-brown-medium leading-relaxed" data-id="element-170">
                    📏{' '}
                    <span className="font-bold text-brown-deep" data-id="element-171">
                      ¿Cuál es mi talle?
                    </span>{' '}
                    Medite la cintura natural (la parte más angosta de tu
                    abdomen) y la cadera (la parte más ancha). Si estás entre
                    dos talles, elegí el más chico: el corset tiene triple
                    hilera de ganchos y se adapta a tu cuerpo.
                  </p>
                </div>

                <div className="overflow-x-auto" data-id="element-172">
                  <table className="w-full text-xs" data-id="element-173">
                    <thead data-id="element-174">
                      <tr className="bg-gold/10 text-brown-deep" data-id="element-175">
                        <th className="px-3 py-2 text-left font-bold" data-id="element-176">Talle</th>
                        <th className="px-3 py-2 text-left font-bold" data-id="element-177">
                          Cintura (cm)
                        </th>
                        <th className="px-3 py-2 text-left font-bold" data-id="element-178">
                          Cadera (cm)
                        </th>
                        <th className="px-3 py-2 text-left font-bold" data-id="element-179">
                          Equiv. ARG
                        </th>
                      </tr>
                    </thead>
                    <tbody data-id="element-180">
                      {[{
                      size: 'S',
                      waist: '60 - 65',
                      hip: '85 - 90',
                      arg: '38/40'
                    }, {
                      size: 'M',
                      waist: '66 - 72',
                      hip: '91 - 96',
                      arg: '42/44'
                    }, {
                      size: 'L',
                      waist: '73 - 80',
                      hip: '97 - 102',
                      arg: '46/48'
                    }, {
                      size: 'XL',
                      waist: '81 - 88',
                      hip: '103 - 108',
                      arg: '50/52'
                    }, {
                      size: '2XL',
                      waist: '89 - 96',
                      hip: '109 - 114',
                      arg: '54/56'
                    }, {
                      size: '3XL',
                      waist: '97 - 105',
                      hip: '115 - 120',
                      arg: '58/60'
                    }].map((row, i) => <tr key={row.size} onClick={() => setSelectedSize(row.size)} className={`cursor-pointer border-t border-gold/10 transition-colors ${selectedSize === row.size ? 'bg-coral/10 font-bold text-coral' : i % 2 === 0 ? 'bg-white hover:bg-rose/20' : 'bg-cream/30 hover:bg-rose/20'}`} data-id="element-181">
                          <td className="px-3 py-2 font-bold" data-id="element-182">{row.size}</td>
                          <td className="px-3 py-2 text-brown-medium" data-id="element-183">
                            {row.waist}
                          </td>
                          <td className="px-3 py-2 text-brown-medium" data-id="element-184">
                            {row.hip}
                          </td>
                          <td className="px-3 py-2 text-brown-medium" data-id="element-185">
                            {row.arg}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>

                <div className="px-4 py-3 bg-amber-50 border-t border-gold/20" data-id="element-186">
                  <p className="text-xs text-brown-medium leading-relaxed" data-id="element-187">
                    ⚠️{' '}
                    <span className="font-bold text-brown-deep" data-id="element-188">
                      Tip de uso:
                    </span>{' '}
                    Los primeros días usá la primera hilera de ganchos (la más
                    floja). A medida que te acostumbrás, pasá a la segunda y
                    tercera. Esto evita molestias y acelera los resultados del
                    Protocolo 21D.
                  </p>
                </div>
              </div>

              {/* Size Selector */}
              <div id="size-selector" className="w-full mb-6" data-id="element-189">
                <div className="flex items-center gap-2 mb-3" data-id="element-190">
                  <Ruler className="w-4 h-4 text-gold" data-id="element-191" />
                  <span className="text-sm font-bold text-brown-deep uppercase tracking-wide" data-id="element-192">
                    Seleccioná tu talle
                  </span>
                  {!selectedSize && <span className="text-xs text-coral font-medium" data-id="element-193">
                      (requerido)
                    </span>}
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-194">
                  {SIZES.map(size => <button key={size.label} onClick={() => setSelectedSize(size.label)} className={`px-4 py-2 rounded-full text-sm font-bold border-2 transition-all duration-200 ${selectedSize === size.label ? 'bg-coral border-coral text-white shadow-md scale-105' : 'bg-white border-gray-200 text-brown-deep hover:border-coral/50 hover:text-coral'}`} data-id="element-195">
                      {size.label}
                    </button>)}
                </div>
                <AnimatePresence data-id="element-196">
                  {selectedSize && <motion.p initial={{
                  opacity: 0,
                  y: -4
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0
                }} className="mt-2 text-xs text-sage font-medium" data-id="element-197">
                      ✓ Talle {selectedSize} seleccionado
                    </motion.p>}
                </AnimatePresence>
              </div>

              {/* Price */}
              <div className="mb-2 text-gray-400 line-through text-xl font-medium" data-id="element-198">
                $89.990
              </div>
              <div className="text-5xl md:text-6xl font-bold text-coral mb-2" data-id="element-199">
                $49.990
              </div>
              <div className="text-lg text-brown-medium font-medium mb-4" data-id="element-200">
                o{' '}
                <span className="font-bold text-brown-deep" data-id="element-201">
                  3 cuotas sin interés de $16.663
                </span>
              </div>
              <div className="inline-block px-4 py-1 bg-green-100 text-green-700 rounded-full text-sm font-bold mb-8" data-id="element-202">
                Ahorrás $40.000 vs. una sesión de estética
              </div>

              {/* CTA */}
              <motion.a id="cta-compra" animate={shakeBtn ? {
              x: [0, -8, 8, -8, 8, 0]
            } : {}} transition={{
              duration: 0.4
            }} href={selectedSizeObj?.url ?? '#size-selector'} target={selectedSizeObj ? '_blank' : undefined} rel="noopener noreferrer" onClick={handleCTAClick} className={`w-full py-4 rounded-full font-bold text-lg shadow-lg transition-all duration-300 transform flex items-center justify-center gap-2 mb-4 group no-underline ${selectedSize ? 'bg-coral hover:bg-coral-dark text-white shadow-coral/30 hover:scale-105' : 'bg-gray-200 text-gray-400 cursor-pointer'}`} data-id="element-203">
                <span data-id="element-204">
                  {selectedSize ? `QUIERO MI KIT TALLE ${selectedSize}` : 'SELECCIONÁ TU TALLE'}
                </span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-205" />
              </motion.a>

              <div className="flex items-center justify-center md:justify-start gap-4 text-xs text-gray-500 w-full" data-id="element-206">
                <div className="flex items-center gap-1" data-id="element-207">
                  <ShieldCheck className="w-4 h-4" data-id="element-208" />
                  <span data-id="element-209">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-210">
                  <CreditCard className="w-4 h-4" data-id="element-211" />
                  <span data-id="element-212">Envío a todo el país</span>
                </div>
              </div>

              {/* Short payment reminder */}
              <div className="mt-5 w-full p-4 rounded-xl bg-[#009ee3]/5 border border-[#009ee3]/20 text-sm text-brown-medium leading-relaxed" data-id="element-213">
                <span className="font-bold text-brown-deep" data-id="element-214">
                  💰 Pago contra entrega con QR de Mercado Pago.
                </span>{' '}
                Escaneás el código cuando el paquete llega a tu puerta. Sin
                efectivo. Sin riesgo. Solo pagás cuando lo tenés. Envíos a todo
                el país.
              </div>
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute inset-0 pointer-events-none border-4 border-gold/10 rounded-3xl animate-pulse-slow" data-id="element-215"></div>
        </motion.div>
      </div>
    </section>;
}